import { render, staticRenderFns } from "./PartProgramConfig.vue?vue&type=template&id=f0df21f6&"
import script from "./PartProgramConfig.vue?vue&type=script&lang=js&"
export * from "./PartProgramConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports